(() => {
  const init = () => document.querySelectorAll('[data-beam-history]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const timeline = root.querySelector('.beam-history__timeline');
    const years = [...root.querySelectorAll('[data-history-year]')];
    const links = [...root.querySelectorAll('.beam-history__chapters a')];
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if ('IntersectionObserver' in window && !motion.matches) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      }), { rootMargin: '0px 0px 80px 0px', threshold: 0 });
      years.forEach(year => observer.observe(year));
      root.classList.add('is-animated');
    }
    const update = () => {
      if (!root.isConnected) return;
      const edge = window.innerHeight * .65;
      const bounds = timeline.getBoundingClientRect();
      const start = parseFloat(getComputedStyle(timeline).paddingTop);
      timeline.style.setProperty('--history-progress', `${Math.max(0, Math.min(bounds.height - start, edge - bounds.top - start))}px`);
      let current = 2002;
      years.forEach(year => {
        const reached = year.getBoundingClientRect().top < edge;
        year.classList.toggle('is-reached', reached);
        if (reached) current = Number(year.dataset.historyYear);
      });
      const index = current >= 2020 ? 3 : current >= 2015 ? 2 : current >= 2009 ? 1 : 0;
      links.forEach((link, i) => i === index ? link.setAttribute('aria-current', 'true') : link.removeAttribute('aria-current'));
    };
    document.addEventListener('scroll', update, { passive: true, capture: true });
    window.addEventListener('resize', update, { passive: true });
    root.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#history-"]');
      if (!link) return;
      const target = root.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      const targetIndex = years.indexOf(target);
      years.slice(0, targetIndex + 1).forEach(year => year.classList.add('is-revealed'));
      target.scrollIntoView({ behavior: motion.matches ? 'instant' : 'smooth', block: 'start' });
      history.replaceState(null, '', link.getAttribute('href'));
      target.tabIndex = -1;
      target.focus({ preventScroll: true });
    });
    update();
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
